import { createSlice as createSliceRedux } from "@reduxjs/toolkit";
import { createSelector as createSelectorRedux } from "@reduxjs/toolkit";

export function createSlice(name, initialState) {
  return createSliceRedux({
    name,

    initialState,

    reducers: {
      update: (state, { payload }) => {
        Object.assign(state, payload);
      }
    }
  });
}

export function createSliceSelector(name) {
  function selectReducer(state) {
    return state[name];
  }

  return function (...params) {
    const fn = params[params.length - 1];
    const selectors = params.slice(0, -1);
    return createSelectorRedux([selectReducer, ...selectors], fn);
  };
}

export { createSelectorRedux as createRootSelector };
